// @eslint-disable
import { useEffect, useState } from 'react';
import { Route, Switch, useParams, useLocation } from 'react-router-dom';
import { GridRowParams } from '@material-ui/data-grid';
import { observer } from 'mobx-react-lite';
import _ from 'lodash';
import { toJS } from 'mobx';
import { ListItem, Typography } from '@material-ui/core';
import credentialStore from '../../state/credentialStore';
import ActionsMenu from '../../components/other/ActionsMenu';
import { gridColumn } from '../../utils/gridUtils';
import { drawerStore } from '../../state/drawerStore';
import { FormInputTypes } from '../../utils/constants';
import { Api } from '../../api';
import { PAGES } from '../../components/main/MainComponent';
import { usePaginatedProvider } from '../../state/paginatedProviderStore';
import { VMPaginatedGrid } from '../../components/main/VMPaginatedGrid';
import {
  TASK_TABS,
  route,
  USER_DETAILS_TABS,
  userDetailsTabParameters,
  tasksTabRoute,
} from '../../utils/routing';
import { ReactComponent as NotificationsIcon } from '../../images/Activities/notifications.svg';
import { ReactComponent as CommentsIcon } from '../../images/Activities/comments.svg';
import TextLink from '../../components/other/TextLink';
import { ViziTab, ViziTabs } from '../../utils/ViziTabs';
import { TaskStatusColors } from '../../types/TaskStatusPill';
import { Task } from '../../types/Charger';
import { TaskLog } from '../../types/TaskLog';
import ActivitiesTable from './ActivitiesTable';

const ActivitiesPage = observer(() => {
  const [createdByUser, setCreatedByUser] = useState(null);
  const location = useLocation();

  const getSubroute = (pathname) => {
    const pathParts = pathname.split('/activities/');
    return pathParts[1];
  };

  useEffect(() => {
    const subRoute = getSubroute(location.pathname);
    if (subRoute === 'my-activities') {
      setCreatedByUser(credentialStore.credentials.user.id);
    } else {
      setCreatedByUser(null);
    }
  }, [location?.pathname]);

  return (
    <div style={{ width: '100%' }}>
      <ViziTabs tabs={[TASK_TABS.ALL, TASK_TABS.MY_ACTIVITIES]} basePath={tasksTabRoute()}>
        <ViziTab label={TASK_TABS.ALL} linkTo={tasksTabRoute(TASK_TABS.ALL)} />
        <ViziTab label={TASK_TABS.MY_ACTIVITIES} linkTo={tasksTabRoute(TASK_TABS.MY_ACTIVITIES)} />
      </ViziTabs>

      <ActivitiesTable createdByUser={createdByUser} />
    </div>
  );
});

const ActivitiesPageWrapper = () => (
  <Switch>
    <Route exact path={route(PAGES.Tasks)} component={ActivitiesPage} />
    <Route path={tasksTabRoute(TASK_TABS.ALL)} component={ActivitiesPage} />
    <Route path={tasksTabRoute(TASK_TABS.MY_ACTIVITIES)} component={ActivitiesPage} />
  </Switch>
);
export default ActivitiesPageWrapper;
